import { useClient } from '@composables/use-clients';
import { GetRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetReviewSkillActionsArgsType = GetRequestArgsType & {
  reviewCode: string;
};

export const apiFetchReviewSkillActions = async ({
  domain = useTenantStore().domain,
  reviewCode,
  errorConfig = {},
  callbacks = {},
}: GetReviewSkillActionsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewSkillActions({ domain, reviewCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
